import routes from '@/modules/contact/contact-routes';
import store from '@/modules/contact/contact-store';
// import OfferAutocompleteInput from '@/modules/offer/components/offer-autocomplete-input';

export default {
  // components: [OfferAutocompleteInput],
  routes,
  store,
};
